export var ImageProcess;
(function (_ImageProcess) {
  function process(url, options) {
    var process = [];
    var crop = options.crop,
      resize = options.resize,
      quality = options.quality,
      format = options.format;
    if (quality) {
      if (!format) {
        format = 'jpg';
      }
    }
    function cmd() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      process.push("/" + args.filter(function (args) {
        return !!args;
      }).join(','));
    }
    if (crop) {
      cmd("crop", "x_".concat(crop.x), "y_".concat(crop.y), "w_".concat(crop.width), "h_".concat(crop.height));
    }
    if (resize) {
      var mode = resize.mode,
        width = resize.width,
        height = resize.height;
      var args = [];
      if (mode) {
        args.push("m_".concat(mode));
      }
      if (width) {
        args.push("w_".concat(width));
      }
      if (height) {
        args.push("h_".concat(height));
      }
      cmd.apply(void 0, ["resize"].concat(args));
    }
    if (format) {
      cmd("format", format);
    }
    if (quality) {
      cmd("quality", "q_".concat(quality));
    }
    if (process.length > 0) {
      return "".concat(url, "?x-oss-process=image").concat(process.join(','));
    }
    return url;
  }
  _ImageProcess.process = process;
})(ImageProcess || (ImageProcess = {}));